module.exports = __webpack_public_path__ + "static/media/HomeImage.aaa9f59a.jpeg";